import { createSlice } from '@reduxjs/toolkit'
import {
  addExistingControl,
  deleteExistingControl,
  getExistingControlbyId,
  getExistingControls,
  getMaturityRateForExistingControl,
  updateExistingControl,
} from './existingControlActions'
// Import the new thunk
import {
  ExistingControl,
  ExistingControlResponse,
  MaturityRateResponse,
} from '../../types/existingControlTypes'
// Import the type for maturity rates

interface ExistingControlState {
  existingControls: ExistingControl[]
  loading: boolean
  existingControl: ExistingControl | null
  error: string | null
  addedExistingControl: ExistingControl | null
  updatedExistingControl: ExistingControl | null
  ExistingControlResponse: ExistingControlResponse | null
  maturityRateResponse: MaturityRateResponse | null // Add maturity rate response
}

const initialState: ExistingControlState = {
  existingControls: [],
  loading: false,
  error: null,
  addedExistingControl: null,
  existingControl: null,
  updatedExistingControl: null,
  ExistingControlResponse: null,
  maturityRateResponse: null,
}

export const existingControlSlice = createSlice({
  name: 'existingControl',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExistingControls.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getExistingControls.fulfilled, (state, action) => {
        state.loading = false
        state.ExistingControlResponse = {
          existingControls: action.payload.existingControls,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
          status: action.payload.status,
          message: action.payload.message,
        }
      })
      .addCase(getExistingControls.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      // New cases for maturity rate
      .addCase(getMaturityRateForExistingControl.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMaturityRateForExistingControl.fulfilled, (state, action) => {
        state.loading = false
        state.maturityRateResponse = action.payload
      })
      .addCase(getMaturityRateForExistingControl.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Failed to fetch maturity rates.'
      })
      .addCase(getExistingControlbyId.pending, (state) => {
        state.loading = true
      })
      .addCase(getExistingControlbyId.fulfilled, (state, action) => {
        state.loading = false
        state.existingControl = action.payload
      })
      .addCase(getExistingControlbyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Failed to fetch ExistingControl.'
      })
  },
})

export default existingControlSlice.reducer
